import Vue from 'vue'
import { notificationMutation } from '@/constants/mutations'
import service from '@/service'
import urlManager from '@/urlManager'
import * as R from 'ramda'

/**
 * This is the store module for Notification Center
 */
export default {
  namespaced: true,
  state: () => ({
    notificationCenter: {}
  }),
  getters: {},
  mutations: {
    [notificationMutation.SET_NOTIFICATIONS_LIST](
      state,
      { orgId, results, next, appendToExistingList, filter }
    ) {
      if (results && appendToExistingList) {
        const prevNotifications = R.pathOr(
          [],
          [orgId, 'notifications', 'results'],
          state.notificationCenter
        )
        results = [...prevNotifications, ...results]
      }
      let notificationsData = state.notificationCenter[orgId] || {}
      notificationsData = R.assoc('notifications', { results, next, filter }, notificationsData)
      Vue.set(state.notificationCenter, orgId, notificationsData)
    },
    [notificationMutation.MARK_NOTIFICATION_AS_READ](state, { orgId, notificationId }) {
      let notifications = R.pathOr([], [orgId, 'notifications'], state.notificationCenter)
      const notificationIndex = notifications.results.findIndex(
        notification => notification.id === notificationId
      )
      notifications = R.assocPath(['results', notificationIndex, 'isUnread'], false, notifications)
      let notificationsData = state.notificationCenter[orgId]
      notificationsData = R.assoc('notifications', { ...notifications }, notificationsData)
      Vue.set(state.notificationCenter, orgId, notificationsData)
    },
    [notificationMutation.SET_NOTIFICATIONS_SUMMARY](state, { orgId, ...payload }) {
      let notificationsData = state.notificationCenter[orgId] || {}
      notificationsData = {
        ...notificationsData,
        ...{ summary: payload, summaryUpdatedAt: Date.now() }
      }
      Vue.set(state.notificationCenter, orgId, notificationsData)
    }
  },
  actions: {
    async getNotificationList({ commit }, { orgId, query = {}, appendToExistingList }) {
      const response = await service.client.get(urlManager.notifications(orgId), {
        params: query
      })
      commit(notificationMutation.SET_NOTIFICATIONS_LIST, {
        ...response.data,
        orgId,
        appendToExistingList,
        filter: { isUnread: query.is_unread }
      })
      const unreadSummary = R.path(['data', 'unreadSummary'], response)
      if (!R.isNil(unreadSummary)) {
        commit(notificationMutation.SET_NOTIFICATIONS_SUMMARY, { ...unreadSummary, orgId })
      }
      return response.data
    },
    async getNotificationSummary({ commit, state }, { orgId }) {
      const lastUpdated = R.path(['notificationCenter', orgId, 'summaryUpdatedAt'], state)
      const oldSummary = R.path(['notificationCenter', orgId, 'summary'], state)
      if (!lastUpdated || Date.now() - lastUpdated > 5000) {
        const response = await service.client.get(urlManager.notificationsSummary(orgId))
        const summaryPayload = { ...response.data, orgId }
        commit(notificationMutation.SET_NOTIFICATIONS_SUMMARY, summaryPayload)
        if (!R.equals(response.data, oldSummary)) {
          commit(notificationMutation.SET_NOTIFICATIONS_LIST, { orgId, results: null })
        }
        return response.data
      } else {
        return oldSummary
      }
    },
    async readNotification({ commit }, { orgId, id }) {
      const response = await service.client.post(urlManager.notification({ orgId, id }), {
        action: 'mark-read'
      })
      commit(notificationMutation.MARK_NOTIFICATION_AS_READ, { orgId, notificationId: id })
      commit(notificationMutation.SET_NOTIFICATIONS_SUMMARY, { orgId, ...response.data })
      return response.data
    },
    async readAllNotifications({ commit }, { orgId, tillId }) {
      const response = await service.client.post(urlManager.readAllNotifications(orgId), {
        tillId
      })
      commit(notificationMutation.SET_NOTIFICATIONS_SUMMARY, { orgId, ...response.data })
      return response.data
    }
  }
}
